import { getYear } from 'date-fns';
import { DateTime } from 'luxon';

enum MONTHS {
	JANUARY = 'January',
	FEBRUARY = 'February',
	MARCH = 'March',
	APRIL = 'April',
	MAY = 'May',
	JUNE = 'June',
	JULY = 'July',
	AUGUST = 'August',
	SEPTEMBER = 'September',
	OCTOBER = 'October',
	NOVEMBER = 'November',
	DECEMBER = 'December',
}

const years = [] as {
	value: number;
	label: number;
}[];

for (let year = 1900; year <= getYear(new Date()); year++) {
	years.push({ value: year, label: year });
}

export { MONTHS, years };

export const EARLIEST_FX_DATE = DateTime.fromISO('1999-01-01', { zone: 'utc' });
